export default {
  hideIframe: true,
  activePage: 'home',
  activeHeaderImage: 'image0.jpeg',
  links: [
    {
      page: 'home',
      image: 'image0.jpeg'
    },
    {
      page: 'story',
      image: 'image1.jpeg'
    },     
    {
      page: 'wedding',
      image: 'image2.jpeg'
    },
    {
      page: 'travel',
      image: 'image3.jpeg'
    }, 
    {
      page: 'activities',
      image: 'image4.jpeg'
    },
    {
      page: 'gallery',
      image: 'image6.jpg'
    },
    {
      page: 'registry',
      image: 'image5.jpg'
    },
    {
      page: 'rsvp',
      image: 'image7.jpg'
    },                   
  ],
  header: {
    main: 'Rajiv & Laura'
  },
  home: {
    names: ['rajiv barton','laura seidel'],
    intro: 'Come celebrate our wedding',
    weddingDate: 'Saturday, October 10, 2020',
  },
  wedding: {
    main: 'Wedding ceremony will begin at 4:00PM<br>Reception to follow<br>Cocktail attire<br>Both our ceremony and reception will be held at:',
    location: {
      header: 'location',
      venue: 'Chateau Of The Isle',
      url: 'https://www.google.com/maps/place/119+Sea+Isle+Dr,+Atlantic+Beach,+NC+28512/@34.688652,-76.8721397,17z',
      addressline1: '119 Sea Isle Drive',
      addressline2: 'Indian Beach, NC 28512',
    },
    events: {
      header: 'Other Events',
      subHeader: 'We will be celebrating at the Chateau all week long starting on Monday, October 5th! We welcome all friends and family to come by the house and spend some time with us enjoying the salty air and relaxing by the pool.',
      event: [
        {
          name: 'Beach Day',
          date: 'Thursday, October 8, 2020',
          time: '11:00 AM - 3:00 PM',
          location: '119 Sea Isle Drive',
          url: 'https://www.google.com/maps/place/119+Sea+Isle+Dr,+Atlantic+Beach,+NC+28512/@34.688652,-76.8721397,17z',
          message: 'If you’ve taken our advice and arrived to paradise early, pack a cooler and join us on the beach for some last minute sunshine.'
        },
        {
          name: 'Welcome Drinks',
          date: 'Friday, October 9, 2020',
          time: '8:00 PM',
          location: 'Crystal Coast Brewing Company',
          url: 'https://crystalcoastbrewingcompany.com/',
          message: 'The bride and groom will be heading to Crystal Coast Brewing Company after our rehearsal Friday night to welcome our out of town guests to the island. Grab a drink at the bar when you arrive and you\'ll find us on the outside patio!'
        },
        {
          name: 'Wedding After Party',
          date: 'Saturday, October 10, 2020',
          time: '10:00 PM',
          location: '',
          url: 'https://www.google.com/maps/place/8102+Emerald+Dr,+Emerald+Isle,+NC+28594/@34.6653619,-77.0364387,17z',
          message: 'If you know Jeeves & Laura, you know the night isn’t over just because the band stopped playing. After the wedding, we will continue the party at a location TBD to keep the party going with the new Mr. & Mrs. Barton.'
        }                
      ]
    },
    story: 'Rajiv and Laura met in his hometown of Columbus, Ohio in Spring 2016 while working their part-time jobs as <a href="https://pedalwagon.com/" target="_blank">Pedal Wagon</a> captains.<br><br>Laura was working on her Masters degree at Ohio State while Rajiv was beginning his career as a web developer after his recent graduation from OSU, and the two fell in love over their shared interest in <strike>Ohio State Football</strike> a good IPA after a long day’s work (it took Laura some time to get Jeeves on the football train, but now he’s all aboard - Go Bucks!)<br><br>They moved to Cincinnati for a short while before finding their newest home in New York City and deciding together forever had a nice ring to it. Laura said ‘yes’ when he popped the question on her 26th birthday last September, and the rest is history.'
  },
  travel: {
    flights: {
      header: 'flights',
      subHeader: 'For those out of towners, your most economical flight options will be into Raleigh Durham International Airport (RDU) or Wilmington International Airport (ILM). From Raleigh or Wilmington, you’ll want to rent a car or hitch a ride with a local to the North Carolina Crystal Coast!',
      extraInfo: 'Regional airport options a bit closer to the beach include:',
      options: [
        {
          airport: 'Albert J Ellis Aiport (OAJ)',
          link: 'https://www.flyoaj.com/'
        },
        {
          airport: 'Coastal Carolina Regional Airport (EWN)',
          link: 'https://www.newbernairport.com/'
        },        
      ]
    },
    lodging: {
      header: 'lodging',
      subHeader: 'We have reserved a block of rooms at the <a href="/">The Inn</a>, only .2 miles from our venue.',
      extraInfo: 'Though the hotel is lovely, we would recommend finding some fellow wedding attendees and checking out Airbnb or VRBO for the perfect local beach house rental.',
      options: [
        {
          hotel: 'Airbnb',
          link: 'https://www.airbnb.com/a/Atlantic-Beach--North-Carolina--United-States'
        },
        {
          hotel: 'VRBO',
          link: 'https://www.vrbo.com/vacation-rentals/usa/north-carolina/coastal/central-coast/atlantic-beach'
        },        
      ]      
    }
  },
  gallery: {
    images: [
      {
        src: 'image4.jpeg'
      },
      {
        src: 'image0.jpeg'
      },
      {
        src: 'image1.jpeg'
      },
      {
        src: 'image2.jpeg'
      },
      {
        src: 'image3.jpeg'
      }                        
    ]
  },
  registry: {
    stores: [
      {
        name: 'amazon',
        url: 'https://www.amazon.com/wedding/laura-seidel-rajiv-barton-indian-beach-october-2020/registry/3NTU3L6I8YS70',
        imageSrc: 'amazon.png',
        alt: 'Amazon logo'
      },
      {
        name: 'williams-sonoma',
        url: 'https://www.williams-sonoma.com/registry/f5sdqmj2sw/registry-list.html',
        imageSrc: 'williams-sonoma.png',
        alt: 'William Sonoma logo'
      },      
    ]
  }
};